// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__1HWQj","hidden":"styles_hidden__bAyP0","shown":"styles_shown__jIteq"};